<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>

  <div class=" h-100 " *ngIf="restoCondition =='1'">
    <div class="container-fluid">
      <div style="width: 100%;height:100%">
        <img src="../../../assets/img/Login_new.jpg" alt="" style="height: 100%;width: 100%;">
      </div>
      <div class="title">
        <div class="content-header_guest logo_image col-sm-12 col-md-12 col-lg-12">
          <img src="../../../assets/img/whitefoodbud.png" width="111px" height="111px" alt="">
          <span class="verified_img" *ngIf="restaurant_verified == 'Active'"
            tooltip="This restaurant is a trusted Foodbud partner" #myTooltip="tooltip">
            <img src="./assets/img/Tick_1.png" alt="" width=20>
          </span>
        </div>
      </div>
      <div align="center" class="col-sm-12 col-md-12 col-lg-12 logo">
        <img src="../../../assets/img/logintext.png" alt="">
      </div>
      <div align="center" class="col-sm-12 col-md-12 col-lg-12 login-btn">
        <button class="btn-defalut" (click)="onClikOtp()">
          <!-- Get Started -->
          Login
        </button>
      </div>
      <div align="center" class="col-sm-12 col-md-12 col-lg-12 skipnowbtn">
        <button class="btn-defalutss" (click)="goToSeeMenu()">
          Skip for now
        </button>
      </div>
    </div>
  </div>
  <div>
  <div class="row h-100 " *ngIf="restoCondition =='3'">
    <div class="col-md-12 my-auto">
      <div class="row justify-content-center">
        <div class="col-md-3">
          <div class="card">
            <div class="content-body">
              <div class="content-header" style="text-align: center;">
                <img src="./assets/img/noresturantavailable.png" [width]="100" [height]="33">
              </div>
              <div class="row guestError" style="justify-content: center;">
                <span>
                  Restaurant is not available.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div style="overflow-x: hidden;background: #fcfcfc;">
    <div *ngIf="restoCondition == '2'">
      <div class="container d-flex justify-content-between">
        <div *ngIf="showAllResto" style="padding-top: 13px;">
          <img src="assets/img/backMenu.svg" alt="" (click)="gotoResto()">
        </div>
        <div style="width: 80%">
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
              (click)="openLocationMap()">
              <mat-expansion-panel-header>
                <mat-panel-description *ngIf="!panelOpenState">
                  <div class="userLocation" *ngIf="userCurrentLocation">{{userCurrentLocation}}</div>
                  <div class="userLocation" *ngIf="!userCurrentLocation">Fetching...</div>
                </mat-panel-description>
                <mat-panel-description *ngIf="panelOpenState">
                  <div>{{userCurrentLocation}}</div>
                </mat-panel-description>
              </mat-expansion-panel-header>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div style="padding-top: 13px;" (click)="goToSearchPage()">
          <img src="../../../assets/img/SearchIcon.svg" alt="">
        </div>
      </div>

      <!-- <div class="container" style="margin-top: -2px;">
        <carousel [images]="images" [cellsToShow]="1" [loop]="true" [margin]="20" [arrows]="false" [autoplay]="true"
          [autoplayInterval]="50000"></carousel>
      </div> -->

      <div class="container resto-text-pad">
        <div class=" d-flex justify-content-between">
          <div class="">
            <p class="restotext">Restaurants near you </p>
          </div>
          <div class="" *ngIf="!showAllResto">
            <p class="view-all-text" (click)="showAllRestos()">View All</p>
          </div>
        </div>
      </div>

      <div style="width: 380px;margin:0 auto;padding: 10px;" *ngIf="!showAllResto">
        <div style="overflow-x: scroll;">
          <div class="">
            <div class="scrollable-resto-div">
              <div class="row">
                <div *ngFor="let alldata of restoOne" style="padding-bottom: 10px;">
                  <div class="scrollable-resto"
                    (click)="onLink(alldata.restaurant_id,alldata.table_id,alldata.visitorOrigin)">
                    <img src="{{alldata.restaurant_image}}" alt="" class="restoImg" style="width: 100%;">
                  </div>
                  <div class="details-div">
                    <div class="tworestodistance">1.6 Km</div>
                    <div class="tworestoRatings"><span><img src="assets/img/star1.svg" alt=""></span><span>4.8</span>
                    </div>
                    <div class="tworestoNames">{{alldata.restaurant_name}}</div>
                    <div class="tworestoAdress">{{alldata.restaurant_address}}</div>
                  </div>
                </div>

                <div *ngFor="let alldata of restoTwo" style="padding-left: 10px;padding-bottom: 10px;">
                  <div class="scrollable-resto"
                    (click)="onLink(alldata.restaurant_id,alldata.table_id,alldata.visitorOrigin)">
                    <img src="{{alldata.restaurant_image}}" alt="" class="restoImg" style="width: 100%;">
                  </div>
                  <div class="details-div">
                    <div class="tworestodistance">1.8 Km</div>
                    <div class="tworestoRatings"><span><img src="assets/img/star1.svg" alt=""></span><span>4.6</span>
                    </div>
                    <div class="tworestoNames">{{alldata.restaurant_name}}</div>
                    <div class="tworestoAdress">{{alldata.restaurant_address}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container" *ngIf="!showAllResto">
        <div>
          <p class="Categories-heading">Categories</p>
        </div>

        <div class="row">
          <div *ngFor="let items of categoryArray" class="cat-div">
            <button class="cat-btn" (click)="getCategoryFilter(items.category_id)"> <span><img src="{{items.image}}"
                  alt=""></span></button>
          </div>
        </div>
      </div>


      <div>
        <div class="container" *ngIf="!showAllResto" style="padding-bottom: 15px;">
          <div>
            <p class="Categories-heading">Your Cuisine</p>
          </div>
        </div>

        <div style="width: 380px;margin:0 auto;padding: 10px;" *ngIf="!showAllResto">
          <div style="overflow-x: scroll;">
            <div class="">
              <div class="scrollable-resto-div">
                <div *ngFor="let items of cuisineArray">
                  <div class="scrollable-cat">
                    <button class="cat-btn" (click)="getCuisineFilter(items.cuisine_id)"> <span><img
                          src="{{items.image}}" style="width: 113px;height:113px;" alt=""></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="showAllResto">
        <div class="container" style="margin-top: -7px;">
          <div *ngFor="let alldata of allrestaurant| filter:searchText ;let i =index" class="cardmaindiv">
            <mat-card (click)="onLink(alldata.restaurant_id,alldata.table_id,alldata.visitorOrigin)">
              <div>
                <div>
                  <img src="{{alldata.featured_image}}" alt="resto-img" class="allRestoImages">
                </div>
                <div class="resto-distance">
                  {{alldata.distance}}
                </div>
              </div>
              <div class="col-12 d-flex justify-content-between">
                <div class="col-10">
                  <div class="resto-name">
                    {{alldata.restaurant_name}}
                  </div>
                </div>
                <div class="col-2">
                  <div class="resto-rating">
                    <span class="star"><img src="assets/img/star1.svg" alt=""></span> <span>4.6</span>
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-between" style="padding-bottom: 10px;">
                <div class="col-10">
                  <div class="resto-address">
                    {{alldata.restaurant_address}}
                  </div>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="restoCondition == '4'">
    <div class="container" style="padding-top: 13px;">
      <div class="d-flex">
        <div class="col-4">
          <img src="assets/img/backMenu.svg" alt="" (click)="gotoRestos()">
        </div>
        <div class="col-6">
          <p class="location">Search</p>
        </div>
      </div>
    </div>
    <div class="blankLine">
      &nbsp;
    </div>

    <div class="container ">
      <div class="searchbar">
        <span style="padding-left: 10px;"><img src="assets/img/SearchIcon.svg" alt=""></span>
        <input type="text" placeholder="Restaurant name or a dish..." class="searchInpBox" [(ngModel)]="searchText"
          (input)="checkFiletered(searchText)">
      </div>
    </div>

    <div class="container" style="margin-top: 7px;" *ngIf="showFilteredResto">
      <div *ngFor="let alldata of allrestaurant| filter:searchText ;let i =index" class="cardmaindiv">
        <mat-card (click)="onLink(alldata.restaurant_id,alldata.table_id,alldata.visitorOrigin)">
          <div>
            <div>
              <img src="{{alldata.featured_image}}" alt="resto-img" class="allRestoImages">
            </div>
            <div class="resto-distance">
              {{alldata.distance}}
            </div>
          </div>
          <div class="col-12 d-flex justify-content-between">
            <div class="col-10">
              <div class="resto-name">
                {{alldata.restaurant_name}}
              </div>
            </div>
            <div class="col-2">
              <div class="resto-rating">
                <span class="star"><img src="assets/img/star1.svg" alt=""></span> <span>4.6</span>
              </div>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-between" style="padding-bottom: 10px;">
            <div class="col-10">
              <div class="resto-address">
                {{alldata.restaurant_address}}
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div *ngIf="restoCondition == '5'">
    <div id="pac-container">
      <input #search id="pac-input" type="text" placeholder="Enter a location">
    </div>
    <div class="container">
      <div id="map">
        <agm-map [zoom]='19' [latitude]="lat" [longitude]="lng">
          <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true" (dragEnd)="markerDragEnd($event)">
          </agm-marker>
        </agm-map>
      </div>
    </div>
  </div>
</div>